import React from "react";
import Home_Cover from "../components/Home_Cover";
import HomeCover_Boxes from "../components/HomeCover_Boxes";
import Collage_Section from "../components/Collage_Section";
import Services_Box from "../components/Services_Box";
import SkillBar_Section from "../components/SkillBar_Section";
import Image_SliderSection from "../components/Image_SliderSection";
import Testimonials from "../components/Testimonials";
import StatsSection from "../components/StatsSection";
import CompanyPartner from "../components/CompanyPartner";
import Contact_Section from "../components/Contact_Section";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <>
      <Home_Cover /> {/*  cover video section */}
      <HomeCover_Boxes /> {/*  three boxes section */}
      <Collage_Section /> {/*  info with image collage  section */}
      <Services_Box /> {/*  Services box details info  section */}
      <SkillBar_Section /> {/*  Skill bar section with half side image */}
      <Image_SliderSection /> {/* the slider section with shankh images*/}
      <Testimonials />
      <StatsSection />
      <CompanyPartner />
      <Contact_Section />
    </>
  );
};

export default Home;
